module.exports = __webpack_public_path__ + "img/buy.36083440.svg";